import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;
let appInsights = null;

if (connectionString) {
    appInsights = new ApplicationInsights({
        config: {
            connectionString,
            enableAutoRouteTracking: true,
            enableUnhandledPromiseRejectionTracking: true,
            correlationHeaderExcludedDomains: [
                '*.b2clogin.com',
                '*.microsoftonline.com',
                'login.microsoftonline.com',
            ],
            samplingPercentage: 100,
        },
    });
    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags || {};
        envelope.tags['ai.cloud.role'] = 'certdrill-frontend';
    });
}

export default appInsights;
